import { useTheme } from '@emotion/react';
import { useAtomValue } from 'jotai';
import React from 'react';

import { Alert, Box, Grid, Text } from '~/components/blocks';
import { OutpatientQuestionnaireSheet } from '~/components/partials/OutpatientQuestionnaireSheet';
import { DirectVisitorDetailDialogProfileFragment } from '~/graphql/generated/graphql';
import { patientDetailDialogProfileState } from '~/state/partials/patient_detail_dialog/atoms';

import { PatientProfile } from './PatientProfile';
import { EditPatientProfile } from './PatientProfile/EditPatientProfile';
import { PrescriptionCollapseFallback } from './PrescriptionCollapseFallback';

type Props = {
  visitor: DirectVisitorDetailDialogProfileFragment;
};

export const DirectVisitorKarte = React.memo((props: Props) => {
  const theme = useTheme();
  const { type } = useAtomValue(patientDetailDialogProfileState);
  const visitDay = props.visitor.createdAt;
  const outpatientQuestionnaireEntry = props.visitor?.outpatientQuestionnaireEntry;

  return (
    <Grid height="100%" overflow="auto" gridTemplateRows="min-content min-content 1fr">
      {type === 'edit' ? (
        <EditPatientProfile guestPatient={props.visitor} />
      ) : (
        <>
          <PatientProfile patient={props.visitor} visitedAt={visitDay} />
          <Box marginTop={theme.space.m}>
            <PrescriptionCollapseFallback />
          </Box>
          <Box marginTop={theme.space.l}>
            <Text fontWeight="bold" marginBottom={theme.space.m}>
              問診
            </Text>
            {outpatientQuestionnaireEntry ? (
              <OutpatientQuestionnaireSheet
                answers={outpatientQuestionnaireEntry.questionnaires}
                enteredAt={outpatientQuestionnaireEntry.enteredAt}
                paddingTop={theme.space.m}
              />
            ) : (
              <Alert status="info">登録患者のため、問診票はありません</Alert>
            )}
          </Box>
        </>
      )}
    </Grid>
  );
});

DirectVisitorKarte.displayName = 'DirectVisitorKarte';
